import './src/vaadin-master-detail-layout.js';

export * from './src/vaadin-master-detail-layout.js';
